import http from '@/libs/http'
export default class FacturasEventoService {
  // generarFacturaEvento (payload) {
  //   return http.post(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/ut-segupharma/facturas/generar`, payload)
  // }
  generarFacturaEvento (payload) {
    return http.post(`${process.env.VUE_APP_MICROSERVICE_API_UT_SEGUPHARMA_FACTURACION_MASIVA}/facturar`, payload)
  }
}
